import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '../types/user'

interface AuthStore {
  user: User | null
  isAuthenticated: boolean
  setUser: (user: User | null) => void
  logout: () => void
}

// persist 미들웨어로 새로고침 후에도 인증 상태 유지
export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,

      setUser: (user) => set({ user, isAuthenticated: !!user }),

      logout: () => {
        // 토큰 제거는 useAuth 훅에서 처리
        set({ user: null, isAuthenticated: false })
      },
    }),
    {
      name: 'saife-auth',
      // 민감 정보 최소화 — 토큰은 별도 tokenStorage 에서 관리
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
)
